import { Condition } from "../domain/Condition.entity";
import { ConditionRepository } from "../infrastructure/condition.repository";

export class ConditionService {
  constructor(private readonly conditionRepository: ConditionRepository) {}

  async getAll(propertyTicker: string): Promise<Condition[]> {
    return await this.conditionRepository.getAll(propertyTicker);
  }
}
